import React, { useEffect, useState } from 'react';
import { resolveProductImageUrl } from '../utils/cartLine';

const PLACEHOLDER =
  'https://images.unsplash.com/photo-1616690002554-b53821496f45?w=400';

const ProductImage = ({
  src,
  alt,
  className = '',
  priority = false,
  soldOut = false,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const imageSrc = failed || !src ? PLACEHOLDER : resolveProductImageUrl(src);

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  return (
    <>
      {!loaded && (
        <div
          className="absolute inset-0 animate-pulse bg-neutral-200"
          aria-hidden
        />
      )}
      <img
        key={src || 'placeholder'}
        src={imageSrc}
        alt={alt}
        width={400}
        height={400}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={priority ? 'high' : 'auto'}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setFailed(true);
          setLoaded(true);
        }}
        className={`w-full h-full object-cover transition-opacity duration-300 ${
          loaded ? 'opacity-100' : 'opacity-0'
        } ${soldOut ? 'grayscale-[35%]' : ''} ${className}`}
      />
    </>
  );
};

export default ProductImage;
